import image1 from '../../../assets/images/WashSelection1.png';
import image2 from '../../../assets/images/WashSelection2.png';
import image3 from '../../../assets/images/WashSelection3.png';
import image4 from '../../../assets/images/WashSelection4.png';
import image5 from '../../../assets/images/WashSelection5.png';
import image6 from '../../../assets/images/WashSelection6.png';
import image7 from '../../../assets/images/WashSelection7.png';
import image8 from '../../../assets/images/WashSelection8.png';
import image9 from '../../../assets/images/WashSelection9.png';
import image10 from '../../../assets/images/WashSelection10.png';
import image11 from '../../../assets/images/WashSelection11.png';
import image12 from '../../../assets/images/WashSelection12.png';
import image13 from '../../../assets/images/WashSelection13.png';
import image14 from '../../../assets/images/WashSelection14.png';
import image15 from '../../../assets/images/WashSelection15.png';
import image16 from '../../../assets/images/WashSelection16.png';
import image17 from '../../../assets/images/WashSelection17.png';

const WCImages = [
    null,
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
];

export default WCImages;
